import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Scrollbar from '../../components/scrollbar'
import { useParams } from 'react-router-dom'
import Discuss from './discuss';
import ServiceSidebar from './sidebar';
import Logo from '../../images/logo.svg'
import Footer from '../../components/footer';
import { queryClient, useFetch } from '../../hooks/useFetch';
import { fetchService } from '../../api/api';
import { useTranslation } from 'react-i18next';


const ServiceSinglePage = (props) => {
    const { id } = useParams()

    const {
        data: service,
        isLoading: serviceIsloading,
        error: serviceError
    } = useFetch(["service", id], (lang) => fetchService(lang, id));

    const services = queryClient.getQueryData(['Services'])?.data?.data;
    const { t } = useTranslation();
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={service?.data?.data?.title} pagesub={t('pageTitles.service')} />
            {serviceIsloading ? <>Loading...</> : serviceError ? <>Error</> : (
                <div className="wpo-service-single-area section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-12">
                                <div className="wpo-service-single-wrap">
                                    <div className="wpo-service-single-item">
                                        <div className="wpo-service-single-main-img">
                                            <img src={`${process.env.REACT_APP_API_URL}/api/images/${service?.data?.data?.thumbnail}`} alt="" />
                                        </div>
                                        <div className="wpo-service-single-title">
                                            <h3>{service?.data?.data?.title}</h3>
                                        </div>
                                    </div>
                                    <div style={{ marginBottom: '50px' }} dangerouslySetInnerHTML={{ __html: service?.data?.data?.content }}></div>
                                    <Discuss />
                                </div>
                            </div>
                            <ServiceSidebar services={services} />
                        </div>
                    </div>
                </div>
            )}

            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;
